
// ------------------------------------------------------------
// Translation strings (Japanese)
// ------------------------------------------------------------

// Core translation keys
const core = {
  // Navigation
  nav_home: 'ホーム',
  nav_about: '会社概要',
  nav_products: '製品',
  nav_news: 'ニュース',
  nav_team: 'チーム',
  nav_careers: '採用情報',
  nav_contact: 'お問い合わせ',

  // Hero Section
  hero_title_line1: 'BUILDING THE',
  hero_title_line2: 'METAVERSE',
  hero_title_line3: 'FUTURE',
  hero_subtitle:
    'Pioneer XR Game Studio | B2B Solutions | Global Innovation',
  hero_cta1: 'EXPLORE PRODUCTS',
  hero_cta2: 'PARTNER WITH US',

  // About Section
  about_badge: 'ABOUT THIRDVERSE',
  about_title_line1: 'PIONEERING THE',
  about_title_line2: 'NEXT GENERATION',
  about_title_line3: 'OF XR EXPERIENCES',
  about_description:
    'バーチャルワールドでの「体験」をアップデートする。Thirdverseは、世界を再定義する次世代のXRゲームスタジオです。クリエイティブな発想と高度な技術力を掛け合わせ、これまでにない没入型インタラクティブ体験を構築。既存の枠組みを打ち破り、XRの限界に挑み続けることで、私たちは世界中の人々に届くエンターテインメントの未来を形にします。',
  about_stat1_number: 'ALL XR',
  about_stat1_label: 'PLATFORMS',
  about_stat2_number: 'GLOBAL',
  about_stat2_label: 'REACH',
  about_cta1: 'MANAGEMENT MEMBERS',
  about_cta2: 'COMPANY PROFILE',

  // Products Section
  products_title: '製品',
  products_subtitle: '没入型VR体験',

  // News Section
  news_title: '最新ニュース',
  news_category_all: 'すべてのニュース',
  news_category_funding: '資金調達',
  news_category_partnerships: 'パートナーシップ',
  news_category_product_launches: '製品発表',
  news_search_placeholder: 'ニュースを検索...',
  news_read_more: '続きを読む',
  news_view_all: 'すべてのニュースを見る',
  news_show_less: '表示を減らす',
  news_back_to_home: '戻る',
  news_share: '共有',
  news_back_to_list: '戻る',

  // Leadership Section
  leadership_title: 'Management Members',
  leadership_subtitle: 'ビジョナリーたち',

  // Career Section
  career_title: '採用情報',
  career_subtitle: 'VRの未来を形作る',
  career_description:
    '私たちは、バーチャルリアリティの未来を創造することに情熱を持つ才能ある人材を常に探しています。ゲーム業界に革命を起こすという私たちの使命に参加してください。',
  career_cta: '募集職種を見る',
  career_join_badge: '採用情報',
  career_hero_title_line1: 'XRの',
  career_hero_title_line2: '未来を',
  career_hero_title_line3: '創る',
  career_hero_description:
    '世界中のプレイヤーに向けた没入型XR体験を構築する、世界クラスのクリエイターとエンジニアのチームに参加しませんか。Thirdverseでは、グローバルな舞台で競争する野心的なプロジェクトに取り組み、バーチャルリアリティの最前線でインタラクティブな世界を形作ります。競争力のある報酬、柔軟な勤務形態、そしてXRの可能性の限界に挑戦する機会を提供します。',
  career_hero_cta: '募集職種を見る',

  // Contact Section
  contact_title: 'お問い合わせ',
  contact_subtitle: 'お気軽にご連絡ください',
  contact_name: 'お名前',
  contact_email: 'メールアドレス',
  contact_message: 'メッセージ',
  contact_send: '送信',
  contact_success: 'メッセージをありがとうございます！すぐにご連絡いたします。',
  contact_error: 'メッセージの送信に失敗しました。もう一度お試しください。',

  // Footer
  footer_about: '会社概要',
  footer_products: '製品',
  footer_news: 'ニュース',
  footer_careers: '採用情報',
  footer_contact: 'お問い合わせ',
  footer_privacy: 'プライバシーポリシー',
  footer_terms: '利用規約',
  footer_rights: 'All rights reserved.',

  // Careers Page (general)
  careers_title: 'Thirdverse 採用情報',
  careers_subtitle: '未来を創造する仲間を募集',
  careers_description:
    '現在、クリエイター全職種で募集をしております。履歴書と職務経歴書を添えて、下記の宛先までメールでお送りください。',
  careers_email_label: 'メールアドレス:',

  // 404 Page
  notfound_title: 'ページが見つかりません',
  notfound_description: 'お探しのページは存在しません。',
  notfound_back: 'ホームに戻る',

  // Privacy Policy
  privacy_title: 'プライバシーポリシー',
  privacy_effective: '施行日: 2024年1月1日',

  // Terms of Service
  terms_title: '利用規約',
  terms_effective: '施行日: 2024年1月1日',
};

// Additional Career‑specific keys that were originally defined in a second object
const careerExtras = {
  careers_hero_badge: '採用情報',
  careers_hero_title_line1: 'XRの',
  careers_hero_title_line2: '未来を',
  careers_hero_title_line3: '創る',
  careers_hero_description:
    '世界中のプレイヤーに向けた没入型XR体験を構築する、世界クラスのクリエイターとエンジニアのチームに参加しませんか。Thirdverseでは、グローバルな舞台で競い合う野心的なプロジェクトに取り組み、バーチャルリアリティの最前線でインタラクティブな世界を形作ります。競争力のある報酬、柔軟な勤務形態、そして世界中のトップタレントと共にXRの限界に挑戦する機会を提供します。',
  careers_open_position_title: '募集職種',
  careers_open_position_subtitle: '中途採用・通年募集',
  careers_message_line1: '現在、全てのクリエイティブ職種を募集しております。',
  careers_message_line2: '履歴書・職務経歴書を下記メールアドレスまでお送りください。',
  careers_note:
    '書類選考を通過された方のみご連絡させていただきます。応募書類は厳重に管理し、採用目的以外には使用いたしません。',
};

// ------------------------------------------------------------
// Export a **single** default object that merges both parts
// ------------------------------------------------------------
export default {
  ...core,
  ...careerExtras,
};
